import './styles/index.scss';
import init from "./views/init";

document.body.onload = init;
